<script>
	import { api } from "./../libs/api.js";

	import { navigate } from 'svelte-routing';
	import { _ } from 'svelte-i18n';

	import BaseLayer from "./../components/BaseLayer.svelte";

	export let id;

	let excursion = api.get_excursion_data(id);

	let questions = [
		'feedback.q1',
		'feedback.q2',
		'feedback.q3',
		'feedback.q4',
		'feedback.q5'
	];
	let answers = new Array(questions.length);

	let emote = {
		SAD: 1,
		MEH: 2,
		HAPPY: 3 
	}

	function handle_emote_selection(answer_id, value) {
		return async function emote_selection(event) {
			answers[answer_id] = value;
		}
	}

	async function handle_submit(event) {
		await api.post_feedback(id, answers);
		navigate("/excursions/" + id, { replace: true });
	}
</script>

<BaseLayer>
	<h2 class="page-title pt-10 pb-6 text-center"> {$_('feedback.give_feedback')} </h2>
	<div class="p-4">
	{#await excursion then value}
		<h3>{$_('feedback.tell_us')}
			{$_('feedback.at')} <b>{value.data.trail_id.title}</b>
			{$_('feedback.on')} <b>{new Date(value.data.date).toLocaleDateString()}</b>
		</h3>

		{#each questions as question, index}
		<div class="card w-full bg-base-100 shadow-xl mb-8">
		  <div class="card-body">
		    <h4 class="card-title"> {$_(question)} </h4>

		    <div class="flex">
		    	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
		    		on:click={handle_emote_selection(index, emote.SAD)}
		    		class="m-2 {answers[index] == emote.SAD ? 'fill-error': ''}">
		    		<path d="M143.9 398.6C131.4 394.1 124.9 380.3 129.4 367.9C146.9 319.4 198.9 288 256 288C313.1 288 365.1 319.4 382.6 367.9C387.1 380.3 380.6 394.1 368.1 398.6C355.7 403.1 341.9 396.6 337.4 384.1C328.2 358.5 297.2 336 256 336C214.8 336 183.8 358.5 174.6 384.1C170.1 396.6 156.3 403.1 143.9 398.6V398.6zM208.4 208C208.4 225.7 194 240 176.4 240C158.7 240 144.4 225.7 144.4 208C144.4 190.3 158.7 176 176.4 176C194 176 208.4 190.3 208.4 208zM304.4 208C304.4 190.3 318.7 176 336.4 176C354 176 368.4 190.3 368.4 208C368.4 225.7 354 240 336.4 240C318.7 240 304.4 225.7 304.4 208zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"/>
		    	</svg>

		    	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
		    		on:click={handle_emote_selection(index, emote.MEH)}
		    		class="m-2 {answers[index] == emote.MEH ? 'fill-warning': ''}">
		    		<path d="M144.4 208C144.4 190.3 158.7 176 176.4 176C194 176 208.4 190.3 208.4 208C208.4 225.7 194 240 176.4 240C158.7 240 144.4 225.7 144.4 208zM368.4 208C368.4 225.7 354 240 336.4 240C318.7 240 304.4 225.7 304.4 208C304.4 190.3 318.7 176 336.4 176C354 176 368.4 190.3 368.4 208zM328 328C341.3 328 352 338.7 352 352C352 365.3 341.3 376 328 376H184C170.7 376 160 365.3 160 352C160 338.7 170.7 328 184 328H328zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464z"/>
		    	</svg>

		    	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
		    		on:click={handle_emote_selection(index, emote.HAPPY)}
		    		class="m-2 {answers[index] == emote.HAPPY ? 'fill-primary': ''}">
		    		<path d="M256 352C293.2 352 319.2 334.5 334.4 318.1C343.3 308.4 358.5 307.7 368.3 316.7C378 325.7 378.6 340.9 369.6 350.6C347.7 374.5 309.7 400 256 400C202.3 400 164.3 374.5 142.4 350.6C133.4 340.9 133.1 325.7 143.7 316.7C153.5 307.7 168.7 308.4 177.6 318.1C192.8 334.5 218.8 352 256 352zM208.4 208C208.4 225.7 194 240 176.4 240C158.7 240 144.4 225.7 144.4 208C144.4 190.3 158.7 176 176.4 176C194 176 208.4 190.3 208.4 208zM304.4 208C304.4 190.3 318.7 176 336.4 176C354 176 368.4 190.3 368.4 208C368.4 225.7 354 240 336.4 240C318.7 240 304.4 225.7 304.4 208zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"/>
		    	</svg>
		    </div>
		  </div>
		</div>
		{/each}

		<div class="text-center my-8">
			<a href="#" class="btn btn-accent w-72 font-bold text-md mt-3 rounded-3xl" on:click={handle_submit}>{$_('feedback.confirm')}</a>
		</div>
		{/await}
	</div>
</BaseLayer>

